"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tokens = {
    breakpoints: {
        medium: 576,
        large: 1024,
        huge: 1280,
    },
    zIndex: {
        0: 0,
        1: 100,
        2: 200,
        3: 300,
        4: 400,
    },
    container: 1140,
};
exports.default = tokens;
